import React, { useEffect } from "react";
import {
    RydInputSource,
    RydManualInputSource,
    RydMidiInputSource
} from "../../audio/input";
import { TrackSourceType } from "../../model/tracks";
import {
    AudioSource,
    listAudioSources
} from "../../audio/routing";
import { MidiDeviceSelectionDialog } from "../midi/MidiDeviceSelectionDialog";
import RydHeaderDialogBox from "../widgets/RydHeaderDialogBox";
import { normalizeClassName } from "../../render/renderUtils";


function renderForSelectedSourceType(
    setSourceCB: (sink: AudioSource) => void,
    trackSourceType?: TrackSourceType,
    source?: RydInputSource,
) {
    if (!trackSourceType) return undefined;
    if (trackSourceType === 'MANUAL') {
        return undefined;
    } else if (trackSourceType === 'MIDIIN') {
        return <MidiDeviceSelectionDialog<AudioSource>
            listSource={listAudioSources}
            selected={(source as RydMidiInputSource)?.midiInput}
            setCB={setSourceCB}
            collapsedClass="flat-left"
        />;
        // } else if (trackSourceType === 'LOOP') {
        //     return undefined;
    }

    return undefined;
}

export function RydTrackSourceSelectionDialog({
    source,
    setSourceCB
}: {
    source?: RydInputSource,
    setSourceCB?: (sink: RydInputSource) => void,
}) {

    const [trackSourceType, setTrackSourceType] = React.useState<TrackSourceType>();
    const [midiSource, setMidiSource] = React.useState<AudioSource>();
    const outputSpecific = renderForSelectedSourceType(setMidiSource, trackSourceType, source);

    useEffect(() => {
        if (source) {
            setTrackSourceType(source.type);

            if (source.type === 'MIDIIN') {
                setMidiSource((source as RydMidiInputSource).midiInput);
            }
        }
    }, []);

    useEffect(() => {
        if (trackSourceType === 'MANUAL') {
            setSourceCB?.(new RydManualInputSource());
        } else if (trackSourceType === 'MIDIIN') {
            if (!midiSource) {
                setSourceCB?.(new RydManualInputSource());
                return;
            }
            setSourceCB?.(new RydMidiInputSource(midiSource.displayName, midiSource.id, midiSource));
            // } else if (trackSourceType === 'LOOP') {
            //     setSourceCB?.(new RydLoopInputSource());
        }
    }, [trackSourceType, midiSource]);

    return (<div className="ryd-instrument-selection-dialog">
        <TrackSourceSelectionDialog
            trackSourceType={trackSourceType}
            setTrackSourceType={setTrackSourceType}
            collapsedClass={trackSourceType === 'MIDIIN' ? 'flat-right' : undefined}
        />
        {outputSpecific}
    </div>);
}

export function TrackSourceSelectionDialog({
    trackSourceType,
    setTrackSourceType,
    collapsedClass,
}: {
    trackSourceType?: TrackSourceType,
    setTrackSourceType: (type: TrackSourceType) => void,
    collapsedClass?: string,
}) {
    const [collapsed, setCollapsed] = React.useState(true);

    if (collapsed) {
        const classes: string[] = [];
        const label = trackSourceType ? trackSourceType : '---';

        return (
            <button
                className={collapsedClass}
                onClick={() => setCollapsed(false)}
            >
                {label}
            </button>
        );
    }

    return (<RydHeaderDialogBox closeCB={() => { setCollapsed(true) }}>
        <ul className={'midi-device-panel--list'}>
            {['MANUAL', 'MIDIIN',
                //'LOOP'
            ].map((sink: TrackSourceType, idx) => {
                const classes = ['ryd-button-option'];
                if (sink === trackSourceType) {
                    classes.push('ryd-button-option--active');
                }
                return (
                    <li key={idx}
                        className={normalizeClassName(classes)}
                        onClick={() => {
                            setTrackSourceType(sink);
                            setCollapsed(true);
                        }}>
                        {sink}
                    </li>
                );
            })}
        </ul>
    </RydHeaderDialogBox>);
}